import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left'
}: SectionHeadingProps) {
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-3xl text-left'} data-id="element-199" data-mp="3f2wy9oywt5ya">
      <p className="mb-4 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary" data-id="element-200" data-mp="3k0f7zhkr3p7c">
        {align === 'center' ? null : <span aria-hidden="true" className="h-px w-6 bg-primary" data-id="element-201" data-mp="gjq0ntdcgbgm" />}
        {eyebrow}
      </p>
      <h2 className="font-display text-3xl font-bold leading-[1.15] tracking-tight text-ink-900 sm:text-4xl" data-id="element-202" data-mp="1vbzrnzhmx2p">
        {title}
      </h2>
      {description ? <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink-500" data-id="element-203" data-mp="6ram7619a50h">
          {description}
        </p> : null}
    </div>;
}